import type { QueryRow } from '../../services/api/dataQa';

export const MAX_VISIBLE_ROWS = 50;

export const isSessionIdCell = (column: string, value: unknown): value is string =>
  /(^|_)session_id$/i.test(column) && typeof value === 'string' && value.length > 0;

export const formatCell = (value: unknown): string => {
  if (value === null || value === undefined) return '–';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

// Semikolon, inte komma: svensk Excel läser då kolumnerna rätt direkt vid inklistring.
const CSV_SEPARATOR = ';';

// Text som börjar med = + - @ eller tab blir en formel när den klistras in i
// Excel. Kundkommentarer är fritext, så de får en inledande apostrof. Tal rörs inte.
const neutralizeFormula = (text: string): string => (/^[=+\-@\t\r]/.test(text) ? `'${text}` : text);

const csvField = (value: unknown): string => {
  if (value === null || value === undefined) return '';
  const text = typeof value === 'number' ? String(value) : neutralizeFormula(formatCell(value));
  return /[;"\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

export const toCsv = (columns: string[], rows: QueryRow[]): string =>
  [columns, ...rows.map((row) => columns.map((column) => row[column]))]
    .map((fields) => fields.map(csvField).join(CSV_SEPARATOR))
    .join('\n');

export const formatDuration = (ms: number): string =>
  ms < 1000 ? `${ms} ms` : `${(ms / 1000).toFixed(1).replace('.', ',')} s`;
